import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { OrganizationMeApi } from "../../../../services/Api/types";

interface Props {
	form: UseFormReturn<OrganizationMeApi>;
}

const InvoiceDetailsContactForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<div className={"row row-cols-md-2"}>
			<div className="col-md-6">
				<FormInput
					label={t("lib:common.word.email")}
					register={register}
					name="contact.email"
					errors={errors}
					help={t("modules.settings.field.invoice_details_email.help_text")}
				/>
			</div>
			<div className="col-md-6">
				<FormInput
					label={t("lib:common.word.phone_number")}
					register={register}
					name="contact.phone_number"
					errors={errors}
				/>
			</div>
		</div>
	);
};

export default InvoiceDetailsContactForm;
